import { ChatItemAssistantTaskController } from './chatAssistantTaskInterface';
import { ChatItemAssistantTaskViewProps, AssistantTaskStatusProps } from './chatAssistantTaskProps';
import { assertNever } from '@varos/util-typescript';
import { Task, TaskStatus } from '@varos/assistant-sdk';
import { GoWorkflow } from 'react-icons/go';
import { ProgressProps } from '@chakra-ui/react';
import { ChatItemAssistantTaskAggregate } from './chatAssistantTaskModel';

export function createChatItemAssistantTaskController(): ChatItemAssistantTaskController {
    function getStatusProps(task: Task): AssistantTaskStatusProps {
        if (task.status === 'running' || task.status === 'pending') {
            return {
                colorScheme: 'blue',
                label: 'In Progress',
                tooltip: null,
            };
        }
        if (task.status === 'completed') {
            return {
                colorScheme: 'green',
                label: 'Completed',
                tooltip: null,
            };
        }
        if (task.status === 'failed') {
            return {
                colorScheme: 'red',
                label: 'Failed',
                tooltip: task.error
                    ? {
                        label: task.error,
                    }
                    : null,
            };
        }
        if (task.status === 'canceled') {
            return {
                colorScheme: 'gray',
                label: 'Canceled',
                tooltip: null,
            };
        }
        assertNever(task.status);
    }

    return {
        useProps(context, item, props): ChatItemAssistantTaskViewProps {
            if (!item.task) {
                return {
                    Icon: GoWorkflow,
                    label: 'Starting task',
                    task: null,
                };
            }
            const status = getStatusProps(item.task);

            return {
                Icon: GoWorkflow,
                label: 'Task started',
                task: {
                    label: item.task.id,
                    status,
                },
            };
        },
    };
}
